export const latestUserInstruction = (messages)=>messages.reduce((latest, message)=>{
        const action = message.toUserAction();
        return (action === null || action === void 0 ? void 0 : action.kind) === 'prompt' ? action.text : latest;
    }, '');
